import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../../services/global';
import { BaseCrudComponent } from '../../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-myroutedetail',
  templateUrl: './myroutedetail.component.html',
  styleUrls: ['./myroutedetail.component.css']
})
export class MyroutedetailComponent extends BaseCrudComponent {

    id:any;
    lat: number = -2.191332;
    lng: number = -79.565221;
    zoom: number = 10;
  	customers:any;
  	showSidebar = false;
  	loadingRequired = false;
  	reception = false;
  	evaluation = false;
  	fields:any;
  	files:any;
  	c_obj:any;

  	currentRate = 3;

  	translations:any;
    momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;

    status:any;
    assigned:any;
    route_obj:any;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
      ) {
        super(srv, modalService, storage, router);
        this.id = route.snapshot.params.id;

        this.read_url = 'LogisticRoute/GetAssignedList';
        this.create_url = '';
        this.update_url = '';
        this.delete_url = '';
        this.search_fields = [];
        this.loadingRequired = false;
        
        let tmp = this.id.split('_');
        this.f_datefrom = tmp[1];
        this.id = tmp[0];

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
            }
        });

        this.customers = [];

        /*this.customers = [
			{name:'ACERIA DEL ECUADOR CA ADELCA.', lat:'-2.191332', lng:'-79.565221', status:'A tiempo', hour:'', address:'', color:'green'},
			{name:'ACERIAS NACIONALES DEL ECUADOR', lat:'-2.262593', lng:'-79.87069', status:'A tiempo', hour:'', address:'', color:'gray'},
			{name:'AGRICOLA COMERCIAL INDUSTRIAL S.A.', lat:'-2.075758', lng:'-79.939412', status:'A tiempo', hour:'', address:'', color:'gray'}
		];*/

		this.fields = [
			{label:'1. PEDIDO COMPLETO', items:[{name:'Recibido correctamente', sel:false},{name:'Opcion 2', sel:false},{name:'Otros', sel:false}]},
			{label:'2. ENTREGA PARCIAL', items:[{name:'Entrega exitosa', sel:false},{name:'Material dañado', sel:false},{name:'Otros', sel:false}]},
			{label:'3. RECHAZADOS', items:[{name:'Entrega NO exitosa', sel:false},{name:'Material dañado', sel:false},{name:'Otros', sel:false}]}
		];

		this.files = [];
		this.c_obj = {img:[{src:'', fname:''}]};
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        //this.f_datefrom = this.curr_date;

        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
        });
    }

    getList(){
        this.clearData();
        this.loadingList = true;
        this.srv.postCall(this.read_url, {date:this.f_datefrom}).subscribe(x => {
            var data = x.data;
            this.loadingList = false;

            if(x.status){
              	//console.log(data);
              	data.forEach(x => {
              		if(x.id == this.id){
              			this.route_obj = x;

              			let i = 0;
              			x.destinations.forEach(d => {
              				let tmp:any;
              				let coords = d.coordinate.split(';');

              				if(i == 0){
              					this.lat = coords[0];
              					this.lng = coords[1];
              				}

              				this.customers.push({
              					name: d.clientName,
              					lat: coords[0],
              					lng: coords[1],
              					status: '',
              					hour: '',
              					address: d.recipientAddress,
              					city: d.recipientCity,
              					phone: d.recipientPhone,
              					invoice: d.invoiceNumber,
              					guide: d.guideNumber,
              					details: d.details,
              					comment: d.comment,
              					color: ''
              				});

              				i++;
              			});
              		}
              	});

              	this.enableSidebar();
            }
        }),
        //timeout(MAX_TIME),
        catchError(data => {return of(false)})
    }

	showCustomerDetails(content:any, obj:any){
		this.reception = false;
		this.evaluation = false;
		this.u_obj = obj;
		this.modalService.open(content, { centered: true });
	}

	disableSidebar(){
		this.showSidebar = false;
	}

	enableSidebar(){
		this.showSidebar = true;
	}

	public closeModal(content: any) {
        this.modalService.dismissAll(content);
    }

    public showReception(){
    	this.reception = true;
    }

    public showEvaluation(){
    	this.reception = false;
    	this.evaluation = true;
    }

    public hideReception(){
    	this.reception = false;
    }

    handleInputChange(e, obj:any) {
	    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
	    var pattern = /image-*/;
	    var reader = new FileReader();
	    /*if (!file.type.match(pattern)) {
	      alert('invalid format');
	      return;
	    }*/

	    //console.log(file);

	    reader.onload = (_event) => { 
	      //this.imgURL = reader.result;
	      obj.img[0].src = reader.result;
	      obj.img[0].fname = file.name;
	    }

	    reader.readAsDataURL(file);
	}

	clearImgPrev(obj:any){
		obj.src = '';
		//console.log(obj);
	}

}
